"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineEditInput = void 0;
var react_1 = __importStar(require("react"));
var Input_1 = require("./Input");
var Loader_1 = require("../Loader");
var Field_1 = require("./Field");
var Feedback_1 = require("./Feedback");
var InlineEditInput = function (props) {
    var fieldProps = props.fieldProps, inputProps = props.inputProps, linkProps = props.linkProps, loaderProps = props.loaderProps, containerProps = props.containerProps, defaultValue = props.defaultValue, renderValue = props.renderValue, onValueSubmitted = props.onValueSubmitted, _a = props.submitOnBlur, submitOnBlur = _a === void 0 ? true : _a, _b = props.submitOnEnter, submitOnEnter = _b === void 0 ? true : _b;
    var _c = react_1.useState(defaultValue), value = _c[0], setValue = _c[1];
    var _d = react_1.useState("view"), state = _d[0], setState = _d[1];
    var _e = react_1.useState(), error = _e[0], setError = _e[1];
    var onClickLink = react_1.useCallback(function () {
        setState("edit");
    }, [setState]);
    var onSubmit = react_1.useCallback(function () {
        setError(undefined);
        setState("loading");
        if (value === defaultValue) {
            setState("view");
            return;
        }
        onValueSubmitted(value)
            .then(function () {
            setState("view");
        })
            .catch(function (e) {
            if (typeof e === "string") {
                setError(e);
            }
            else {
                setError("Unknown Error Occurred");
            }
            setState("edit");
        });
    }, [value, defaultValue, onValueSubmitted]);
    var onKeyUp = react_1.useCallback(function (e) {
        switch (e.key) {
            case "Escape":
                e.preventDefault();
                e.stopPropagation();
                setValue(defaultValue);
                setState("view");
                setError(error);
                break;
            case "Enter":
                if (submitOnEnter) {
                    e.preventDefault();
                    e.stopPropagation();
                    onSubmit();
                }
                break;
        }
    }, [onSubmit, setValue, setState]);
    var onChange = react_1.useCallback(function (e) {
        var val = typeof defaultValue === "number" ? parseFloat(e.target.value) : e.target.value;
        // @ts-ignore
        setValue(val);
    }, [setValue]);
    return (react_1.default.createElement("div", __assign({}, containerProps),
        state === "view" && (react_1.default.createElement("a", __assign({}, linkProps, { onClick: onClickLink }), renderValue ? renderValue(defaultValue) : defaultValue)),
        state === "loading" && react_1.default.createElement(Loader_1.Loader, __assign({ thickness: Loader_1.Loader.Thickness.Thin }, loaderProps)),
        state === "edit" && (react_1.default.createElement(Field_1.Field, __assign({ feedback: error ? Field_1.Field.Feedback.Error : undefined, feedbackText: error ? error : undefined }, fieldProps),
            react_1.default.createElement(Input_1.Input, __assign({ defaultValue: defaultValue, onBlur: submitOnBlur ? onSubmit : undefined, onKeyUp: onKeyUp, onChange: onChange, autoFocus: true, feedback: error ? Feedback_1.Feedback.Error : undefined }, inputProps))))));
};
exports.InlineEditInput = InlineEditInput;
exports.InlineEditInput.displayName = "InlineEditInput";
//# sourceMappingURL=InlineEditInput.js.map